import { render, staticRenderFns } from "./BaseDataTableList.vue?vue&type=template&id=516d426e"
import script from "./BaseDataTableList.vue?vue&type=script&lang=js"
export * from "./BaseDataTableList.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTableList.vue?vue&type=style&index=0&id=516d426e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports